import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Button, Text } from 'src/packages/core';
import { ChevronRightIcon, ChevronLeftIcon } from 'src/packages/icons';
import { DarkTheme, LightTheme } from 'src/packages/theme';

import { PaginationWrapper } from './Pagination.styles';
import { PaginationProps } from './Pagination.types';

const Pagination = ({
  theme,
  activePage,
  totalPages,
  onNextClick,
  onPageNumClick,
  onPreviousClick,
  nextDisabled,
  previousDisabled,
}: PaginationProps) => {
  const contextTheme = useTheme();

  const defaultTheme = useMemo(() => {
    return theme
      ? theme === 'light'
        ? { ...LightTheme, rtl: contextTheme.rtl }
        : { ...DarkTheme, rtl: contextTheme.rtl }
      : contextTheme;
  }, [contextTheme, theme]);

  //get pagination numbers with dots
  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages! <= 4 || totalPages! - 1 <= 4) {
      for (let i = 1; i <= totalPages!; i++) {
        pageNumbers.push(i);
      }
    } else if (activePage! <= 3) {
      for (let i = 1; i <= 4; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push('...');
      pageNumbers.push(totalPages);
    } else if (activePage! >= totalPages! - 2) {
      pageNumbers.push(1);
      pageNumbers.push('...');
      for (let i = totalPages! - 3; i <= totalPages!; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);
      pageNumbers.push('...');
      for (let i = activePage! - 1; i <= activePage! + 1; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push('...');
      pageNumbers.push(totalPages);
    }
    return pageNumbers;
  };

  return (
    <PaginationWrapper defaulttheme={defaultTheme} themetype={theme}>
      <Button
        text=''
        disabled={previousDisabled || (!!activePage && activePage === 1)}
        onClick={onPreviousClick}
        rightIcon={<ChevronLeftIcon />}
      />

      {totalPages &&
        activePage &&
        getPageNumbers().map((pageNumber, index) =>
          pageNumber!.toString().includes('...') ? (
            <Text text={pageNumber!.toString()} variant='p3' key={index} />
          ) : (
            <Button
              text={pageNumber!.toString()}
              key={index}
              onClick={() => onPageNumClick && onPageNumClick(Number(pageNumber))}
              className={pageNumber === activePage ? 'active' : ''}
            />
          )
        )}
      <Button
        disabled={nextDisabled || (!!totalPages && activePage === totalPages)}
        onClick={onNextClick}
        rightIcon={<ChevronRightIcon />}
      />
    </PaginationWrapper>
  );
};

export default Pagination;
